import map from 'lodash/map';

import React from 'react';
import PropTypes from 'prop-types';
import { round4, round5 } from 'utilities/math';

const COLUMNS = [
  'Formula',
  'Residual Standard Error',
  'Correlation',
  'R²',
  'F-Statistic',
  'Degrees of Freedom',
  'p-value'
];

class ModelSummaryTableComponent extends React.PureComponent {
  static propTypes = {
    formula: PropTypes.string.isRequired,
    rse: PropTypes.number.isRequired,
    dof: PropTypes.number.isRequired,
    correlation: PropTypes.number,
    r2: PropTypes.number.isRequired,
    f: PropTypes.number.isRequired,
    p: PropTypes.number.isRequired
  }

  render () {
    return (
      <div id="model-summary-table" className="content-item mb-15">
        <p className="font-700 mb-10">
          {'Model\'s Summary Table'}
        </p>

        <table className="main-table">
          <thead>
            <tr>
              {map(COLUMNS, column =>
                (column === 'Correlation' && !this.props.correlation)
                  ? null
                  : (
                    <th className="text-right" key={column}>
                      {column}
                    </th>
                  )
              )}
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className="text-right" id="formula">
                {this.props.formula}
              </td>

              <td className="text-right" id="rse">
                {round5(this.props.rse)}
              </td>

              {this.props.correlation &&
                <td className="text-right" id="correlation">
                  {round5(this.props.correlation)}
                </td>
              }

              <td className="text-right" id="r2">
                {round4(this.props.r2)}
              </td>

              <td className="text-right" id="f">
                {this.props.f.toExponential(3)}
              </td>

              <td className="text-right" id="dof">
                {this.props.dof}
              </td>

              <td className="text-right" id="p">
                {this.props.p.toExponential(3)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default ModelSummaryTableComponent;
